import { apiClient } from "../../api/apiClient";
import merge from "lodash/merge";

export const fetchDocumentsAsync = (options) => {
  const defaultOptions = {
    params: {
      sort: `["createdAt","DESC"]`,
      range: "[0, 999]",
    },
  };
  return apiClient().get("documents", merge(defaultOptions, options));
};

export const fetchDocumentCategoriesAsync = (options) => {
  const defaultOptions = {
    params: {
      sort: `["createdAt","DESC"]`,
    },
  };
  return apiClient().get(
    "documents/_categories",
    merge(defaultOptions, options),
  );
};
